import { put, select, takeEvery } from 'redux-saga/effects';

import * as auditActions from './actions';
import * as historyActions from '../actions';
import { getType } from 'typesafe-actions';

import { selectNextLogsForSync } from './selectors';
import { triggerLegacyAppSync } from 'src/modules/appSync/actions';
import { logError } from 'src/utils/ErrorLogger';
import { getAuthToken } from 'src/containers/Auth/selectors';

import { makeGetPagesHistoryAnyPage } from '../selectors';
import * as syncApi from './api';
import { appGoOnline, appStateRestored } from 'src/containers/App/actions';
import { updateUserProfileInfo } from 'src/containers/UserProfile/actions';
import { authSignInSuccess } from 'src/containers/Auth/actions';

const syncWithServer = async (token: string, action: auditActions.SyncAction) => {
  switch (action.type) {
    case getType(auditActions.syncActions.onPageCreated):
    case getType(auditActions.syncActions.onPageUpdated): {
      const updatedPage = await syncApi.updatePage(token, action.payload);
      return historyActions.pageSynced(updatedPage);
    }
    case getType(auditActions.syncActions.onPageDeleted): {
      const updatedPage = await syncApi.deletePage(token, action.payload);
      return historyActions.pageSynced(updatedPage);
    }
    default: {
      throw new Error(`Unsupported sync action:${action}`);
    }
  }
};

function* sync() {
  const token = yield select(getAuthToken);

  if (!token) {
    return;
  }

  const nextSyncActions: auditActions.SyncAction[] = yield select(selectNextLogsForSync);

  yield put(auditActions.controlActions.startAppSync());

  yield put(triggerLegacyAppSync());

  for (const syncAction of nextSyncActions) {
    try {
      const resultAction = yield syncWithServer(token, syncAction);

      yield put(resultAction);

      yield put(auditActions.controlActions.markLogAsSynced(syncAction.meta.id));
    } catch (err) {
      logError(err);
      yield put(auditActions.controlActions.appSyncError(err.message));
    }
  }

  yield put(historyActions.refreshPagesHistory());

  yield put(historyActions.updatePagesHistoryLastSyncDate(new Date()));

  yield put(auditActions.controlActions.appSyncSuccess());
}

export default function* auditSaga() {
  const actions = Object.keys(auditActions.syncActions).map(key => getType(auditActions.syncActions[key]));

  actions.push(getType(appStateRestored));
  actions.push(getType(appGoOnline));
  actions.push(getType(updateUserProfileInfo));
  actions.push(getType(authSignInSuccess));

  yield takeEvery(actions, sync);

  yield takeEvery(getType(historyActions.createPage), function*(action: ReturnType<typeof historyActions.createPage>) {
    const page = yield select(makeGetPagesHistoryAnyPage(action.payload.dateId));
    yield put(auditActions.syncActions.onPageCreated(page));
  });

  yield takeEvery(getType(historyActions.updatePage), function*(action: ReturnType<typeof historyActions.updatePage>) {
    const page = yield select(makeGetPagesHistoryAnyPage(action.payload.dateId));
    yield put(auditActions.syncActions.onPageUpdated(page));
  });

  yield takeEvery(getType(historyActions.deletePage), function*(action: ReturnType<typeof historyActions.deletePage>) {
    const page = yield select(makeGetPagesHistoryAnyPage(action.payload.dateId));
    yield put(auditActions.syncActions.onPageDeleted(page));
  });
}



// WEBPACK FOOTER //
// ./src/containers/PagesHistory/AuditLog/saga.ts